
      <div class="ui-g-12 sf-field-container">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [attr.for]="id" [ngClass]="{'required': -1!==(formProperty.parent.schema.required||[]).indexOf(formProperty.path.split('/').slice(-1)[0])}">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <div *ngFor="let option of schema.oneOf" class="sf-radio">
            <p-radioButton
              [name]="name"
              [value]="option.enum[0]"
              [formControl]="control"
              label="{{option.description || (schema.hasOwnProperty('title') ? schema.title :formProperty.path) + ' ' + option.enum[0]}}"
              [disabled]="schema.readOnly||false"
            ></p-radioButton>
          </div>
        </div>
      </div>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/radio.widget.ts.RadioWidget.html